import { render } from "./ListNoRequest.vue?vue&type=template&id=638b49a6&scoped=true"
import script from "./ListNoRequest.vue?vue&type=script&lang=js"
export * from "./ListNoRequest.vue?vue&type=script&lang=js"

import "./ListNoRequest.vue?vue&type=style&index=0&id=638b49a6&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638b49a6"]])

export default __exports__